import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const getPlatforms = (
	params = {
		per_page: 10,
		page: 1,
		'filter[term]': '',
	},
) => Http.get(`/platforms/fetch${serialize(params)}`)

export const getPlatformBySlug = slug => Http.get(`/platforms/${slug}/show`)

export const savePlatform = params => Http.post(`/platforms/store`, params)

export const updatePlatform = params => Http.put(`/platforms/${params.platformSlug}/update`, params)

export const destroyPlatform = params => Http.delete(`/platforms/${params.platformSlug}/destroy`)

export const getPlatformWebsiteCategories = (params = {}) =>
	Http.get(`/platform-website-categories/fetch${serialize(params)}`)
